import React from 'react';
import { useTheme } from '@mui/material';
import {
    PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { VideoLibrary as VideoLibraryIcon } from '@mui/icons-material';
import ChartCard from './ChartCard';

const TYPE_COLORS = {
    VIDEO:         '#FF0000',
    SHORT:         '#FF6B6B',
    IMAGE:         '#E1306C',
    REELS:         '#C13584',
    CAROUSEL_ALBUM:'#833AB4',
    PHOTO:         '#1877F2',
    TEXT:          '#90CAF9',
    UNKNOWN:       '#9E9E9E',
};

const TYPE_LABELS = {
    VIDEO:          'Videos',
    SHORT:          'Shorts',
    IMAGE:          'Images',
    REELS:          'Reels',
    CAROUSEL_ALBUM: 'Carousel',
    PHOTO:          'Photos',
    TEXT:           'Text Posts',
    UNKNOWN:        'Other',
};

const ContentTypeChart = ({ data, height = 280 }) => {
    const theme = useTheme();
    if (!data || data.length === 0) return null;

    const pieData = data.map(d => ({
        name: TYPE_LABELS[d.type] || d.type,
        value: d.count,
        views: d.views,
        color: TYPE_COLORS[d.type] || '#9E9E9E',
    }));

    return (
        <ChartCard title="Content Type Breakdown" icon={<VideoLibraryIcon />} height={height}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={pieData}
                        cx="50%"
                        cy="45%"
                        innerRadius={55}
                        outerRadius={85}
                        paddingAngle={3}
                        dataKey="value"
                        stroke="none"
                    >
                        {pieData.map((entry, i) => (
                            <Cell key={i} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            background: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: 12,
                            boxShadow: '0 10px 30px -10px rgba(0,0,0,0.15)',
                            fontWeight: 600,
                        }}
                        formatter={(value, name, props) => [
                            `${value} posts · ${(props.payload.views || 0).toLocaleString()} views`,
                            name,
                        ]}
                    />
                    <Legend
                        iconType="circle"
                        iconSize={8}
                        wrapperStyle={{ paddingTop: 8, fontSize: 12 }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </ChartCard>
    );
};

export default ContentTypeChart;
